import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "athlete" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const set = (k, v) => setForm({ ...form, [k]: v });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(form);
      toast.success("Account created. Let's get to work.");
      navigate("/dashboard");
    } catch (e) { setErr(e.message); }
    setLoading(false);
  };

  return (
    <div className="section-dark min-h-screen flex items-center py-16">
      <div className="container-app grid md:grid-cols-2 gap-12">
        <div>
          <div className="label-tag mb-4">Join</div>
          <h1 className="font-heading font-black uppercase text-5xl md:text-7xl leading-none"><span className="metallic-gold">Enter</span><br/>the pipeline.</h1>
          <p className="mt-8 text-white/70 max-w-md">Create your account to start training, build your recruiting profile, and connect with coaches.</p>
          <div className="mt-10 grid grid-cols-2 gap-4">
            {[
              ["Athlete", "Train, build profile, get recruited."],
              ["Coach", "Search & connect with recruits."],
            ].map(([role, desc]) => (
              <button type="button" key={role} onClick={() => set("role", role.toLowerCase())}
                data-testid={`register-role-${role.toLowerCase()}`}
                className={`text-left p-5 border transition-all ${form.role === role.toLowerCase() ? "border-[color:var(--gold)] bg-black" : "border-white/15 bg-transparent"}`}>
                <div className="font-heading uppercase font-bold text-lg">{role}</div>
                <div className="text-white/60 text-xs mt-2">{desc}</div>
              </button>
            ))}
          </div>
        </div>

        <div className="card-dark p-10">
          <form onSubmit={submit} className="space-y-8">
            <Field label="Full Name" testid="register-name-input" value={form.name} onChange={(v)=>set("name",v)} />
            <Field label="Email" type="email" testid="register-email-input" value={form.email} onChange={(v)=>set("email",v)} />
            <Field label="Password" type="password" testid="register-password-input" value={form.password} onChange={(v)=>set("password",v)} />
            {err && <div className="text-red-400 text-sm" data-testid="register-error">{err}</div>}
            <button disabled={loading} className="btn-gold w-full justify-center" data-testid="register-submit-btn">{loading ? "…" : "Create Account"}</button>
            <div className="text-white/60 text-sm">Already have one? <Link to="/login" className="text-[color:var(--gold)] hover:underline" data-testid="link-login">Log in</Link></div>
          </form>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", testid }) {
  return (
    <div>
      <label className="label-tag" style={{ color: "#A3A3A3" }}>{label}</label>
      <input required type={type} value={value} onChange={(e)=>onChange(e.target.value)} className="input-sharp mt-2" data-testid={testid} />
    </div>
  );
}
